import Moment from 'moment';
import { DataStatisticApi } from '../../api';
import MaterialTableComponent from '../../../components/module/table/materialTableComponent';
import React, { ReactElement } from 'react';

export const compareToDayLessOne = (pLines: any) => {
  const dateToCompare = Moment(pLines.recordDate).format('DD/MM/YYYY');
  const dDay = Date.now();
  const dateToBeEqual = Moment(dDay).subtract(1, 'days').format('DD/MM/YYYY');
  if (dateToCompare === dateToBeEqual) {
    return false;
  } else {
    // color in red
    return true;
  }
};

export const compareMultipleDates = (pLines: any) => {
  const recordDate = Moment(pLines.recordDate).format('DD/MM/YYYY');
  const integrationDate = Moment(pLines.integrationDate).format('DD/MM/YYYY');
  const dDay = Date.now();
  const recordDateToBeEqual = Moment(dDay)
    .subtract(1, 'days')
    .format('DD/MM/YYYY');
  if (
    recordDate === recordDateToBeEqual &&
    integrationDate === Moment(dDay).format('DD/MM/YYYY')
  ) {
    return false;
  } else {
    // color in red
    return true;
  }
};

export const ruleOne = (pLines: any) => {
  const integrationDate = Moment(pLines.integrationDate).format('DD/MM/YYYY');
  const dDay = Moment(Date.now()).format('DD/MM/YYYY');
  if (dDay === integrationDate) {
    return false;
  } else {
    // color in red
    return true;
  }
};

export const ruleTwo = (pLines: any) => {
  if (
    pLines.object === 'ValueRecording' ||
    pLines.object === 'DiagPermIndicator'
  ) {
    return compareToDayLessOne(pLines);
  } else {
    return false;
  }
};

export const ruleThree = (pLines: any) => {
  if (
    pLines.object === 'CategoryMainInstall' &&
    pLines.statsIndicator === 'DIAGPERM-VARIABLES_CATEGORISE_LAST_DAY'
  ) {
    return compareToDayLessOne(pLines);
  } else {
    return false;
  }
};

export const ruleFour = (pLines: any) => {
  if (
    pLines.object === 'VariableCategorization' &&
    pLines.statsIndicator === 'DIAGPERM-VARIABLES_CATEGORISE_LAST_DAY'
  ) {
    return compareToDayLessOne(pLines);
  } else {
    return false;
  }
};

export const ruleFive = (pLines: any) => {
  if (pLines.object === 'IndicatorCategorization') {
    return compareMultipleDates(pLines);
  } else {
    return false;
  }
};

export const ruleSix = (pLines: any) => {
  if (
    pLines.object === 'CategoryMainInstall' &&
    pLines.statsIndicator === 'DIAGPERM-VARIABLES_CATEGORISE_LAST_DAY'
  ) {
    return compareMultipleDates(pLines);
  } else {
    return false;
  }
};

export const ruleSeven = (pLines: any) => {
  if (pLines.object === 'RemoteMgtVariable') {
    return compareToDayLessOne(pLines);
  } else {
    return false;
  }
};

export const applyRules = (pDataFromApi: any) => {
  const dataFromApi = pDataFromApi;
  const lines = document.getElementsByClassName('rt-tbody')[0].children;

  // apply colorization
  dataFromApi.forEach((line: any, index: number) => {
    if (ruleOne(line) === true) {
      lines[index].setAttribute('style', 'color: red;');
    } else {
      if (ruleTwo(line) === true) {
        lines[index].setAttribute('style', 'color: red;');
      } else {
        if (ruleThree(line) === true) {
          lines[index].setAttribute('style', 'color: red;');
        } else {
          if (ruleFour(line) === true) {
            lines[index].setAttribute('style', 'color: red;');
          } else {
            if (ruleFive(line) === true) {
              lines[index].setAttribute('style', 'color: red;');
            } else {
              if (ruleSix(line) === true) {
                lines[index].setAttribute('style', 'color: red;');
              } else {
                if (ruleSeven(line) === true) {
                  lines[index].setAttribute('style', 'color: red;');
                } else {
                  lines[index].setAttribute('style', 'color: green;');
                }
              }
            }
          }
        }
      }
    }
  });
};

export const getStatistic = async (
  start: any,
  end: any,
  obj: any,
  reg: any,
  typ: any,
  measure: any,
  setLoading: React.Dispatch<React.SetStateAction<boolean>>,
  setStatiticList: React.Dispatch<React.SetStateAction<never[]>>,
  toastInf: React.MutableRefObject<any>,
) => {
  try {
    setLoading(true);
    const response = await DataStatisticApi.getDataStatistic(
      start,
      end,
      obj,
      reg,
      typ,
      measure,
    );
    setStatiticList(response.data);
    // color lines
    applyRules(response.data);
    setLoading(false);
  } catch {
    setLoading(false);
    toastInf.current?.show({
      severity: 'error',
      summary: 'Erreur ',
      detail:
        ' Nous avons rencontré un soucis dans la prise en compte de votre demande. Veuillez réessayer ou contacter votre administrateur',
      life: 15000,
    });
  }
};

//Table de réponse des filtres
export function renderTableData(
  datcol: any,
  statiticList: never[],
): ReactElement {
  return (
    <MaterialTableComponent columns={datcol} rows={statiticList} rowsPerPage={10} />
  );
}
